import { Bot, Clock3 } from 'lucide-react'
import type { Copy, Publication } from '@/frontend/features/DashboardRuntime/types'

export default function PublicationByline({ publication, copy, compact = false }: { publication: Pick<Publication, 'author' | 'published_at' | 'version'>; copy: Copy; compact?: boolean }) {
  const date = publication.published_at ? new Date(publication.published_at) : null
  const formatted = date && !Number.isNaN(date.valueOf())
    ? new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(date) : null
  return <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-xs leading-5 text-muted-foreground">
    <span className="inline-flex items-center gap-1.5" title={copy.published_by}>
      {!compact && <Bot className="size-3.5 shrink-0" aria-hidden />}
      {publication.author?.name ?? copy.unknown_author}
    </span>
    {publication.version && <span className="inline-flex items-center gap-1.5" title={copy.published_at}>
      {compact && <span aria-hidden className="mr-1 text-border">·</span>}
      {!compact && <Clock3 className="size-3.5 shrink-0" aria-hidden />}
      {formatted ? <time dateTime={publication.published_at!}>{copy.published_at} {formatted}</time> : copy.unknown_date}
    </span>}
  </div>
}
